import React, { useEffect, useState } from "react";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector, useDispatch } from "react-redux";
import Spinner from "../../spinner";
import moment from "moment";
import { setJobScheduleList } from "../../../../store/reducers/menu";
import Toast from "../../toast";
import { useLocation } from "react-router-dom";

const dayMap = {
  sunday: 'Sun',
  monday: 'Mon',
  tuesday: 'Tue',
  wednesday: 'Wed',
  thursday: 'Thu',
  friday: 'Fri',
  saturday: 'Sat'
};

const fullDayMap = {
  sunday: 'Sunday',
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday'
};


const ScheduleJobScreen = ({
  formValues,
  setFormValues,
  formErrors,
  setFormErrors,
  handleChange,
  handleDatePickerChange,
  empDetailsInfo,
  handleJobSubmit,
  handleTimeChange,
  isLoading,
  setShowScheduleScreen,
  validateForm,
  getCurrentClockinClockoutTime,
  handleHideJobType,
  multiFormValues,
  setMultiFormValues,
  multiFormErrors,
  setMultiFormErrors,
  setFormModified,
  formModified,
}) => {
  const { userInfo, jobScheduleList, workHoursEnabled } = useSelector((state) => state.menu);
  const dispatch = useDispatch();
  const location = useLocation();

  const [selectedDays, setSelectedDays] = useState([]);
  const [scheduleList, setScheduleList] = useState([]);
  const [errSuccessMesg, setErrSuccessMsg] = useState({
    message: "",
    status: "",
  });
  const [isEditing, setIsEditing] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    console.log("jobScheduleList=======",formModified, userInfo, jobScheduleList);
    if (scheduleList?.length > 0) {
      const array = formModified;
      while (formModified?.length < scheduleList?.length) {
        array.push(false);
      }
      console.log("arrayyyyyy", array)
      setFormModified(array)
      dispatch(setJobScheduleList(scheduleList));
    } else {
      setScheduleList(jobScheduleList);
    }
  }, [scheduleList]);

  useEffect(() => {
    setOpenIndex(0);
    if(!location?.state?.id && !location?.state?.multipleDayJob){
      setFormValues((prevValues) => ({
        ...prevValues,
        ...scheduleList[0],
      }));
    }
  },[]);

  console.log("scheduleList=============",formValues, scheduleList);
  console.log("multiFormValues=================",multiFormValues)
  console.log("multiFormErrors==========",multiFormErrors)

  const daysOfWeek = [
    { label: "S", value: "Sunday" },
    { label: "M", value: "Monday" },
    { label: "T", value: "Tuesday" },
    { label: "W", value: "Wednesday" },
    { label: "T", value: "Thursday" },
    { label: "F", value: "Friday" },
    { label: "S", value: "Saturday" },
  ];

    const findNextValidDate = (startDateStr, endDateStr, selectedDays) => {
    let startDate = moment(startDateStr, "YYYY-MM-DD HH:mm:ss").startOf('day');
    const endDate = moment(endDateStr, "YYYY-MM-DD HH:mm:ss").endOf('day');
  
    while (startDate.isSameOrBefore(endDate)) {
      if (selectedDays.includes(startDate.day())) {
        return startDate;
      }
      startDate.add(1, 'day');
    }
      return null;
    };

    const isJobStartTimeValid = (jobSchedule) => {
    if (!jobSchedule) return false;
  
    const {
      startTime,
      startDate,
      endDate,
      sunday,
      monday,
      tuesday,
      wednesday,
      thursday,
      friday,
      saturday,
    } = jobSchedule;
  
    const selectedDays = [];
    if (sunday) selectedDays.push(0);
    if (monday) selectedDays.push(1);
    if (tuesday) selectedDays.push(2);
    if (wednesday) selectedDays.push(3);
    if (thursday) selectedDays.push(4);
    if (friday) selectedDays.push(5);
    if (saturday) selectedDays.push(6);
  
    const nextValidDate = findNextValidDate(startDate, endDate, selectedDays);
    if (!nextValidDate) return false;
  
    // Extract only the time from startTime
    const timeOnly = moment(startTime, "YYYY-MM-DD HH:mm:ss").format("HH:mm:ss");
  
    // Combine next valid date with time
    const fullDateTime = moment(`${nextValidDate.format("YYYY-MM-DD")} ${timeOnly}`, "YYYY-MM-DD HH:mm:ss");
  
    // Check if it's more than 60 minutes ahead
    return fullDateTime.diff(moment(), "minutes") > 60;
  };

  useEffect(() => {
   if(location?.state?.id && location?.state?.multipleDayJob){
      const schedule_list = fetchJobScheduleList(location?.state?.jobScheduleEntitiesDto);

      // const shouldUseLocationTime = moment(schedule_list[0]?.startTime, "YYYY-MM-DD HH:mm:ss").diff(moment(), "minutes") > 60;      
      const shouldUseLocationTime = isJobStartTimeValid(schedule_list[0])

      if(shouldUseLocationTime){
        setMultiFormValues(schedule_list);
        setScheduleList(schedule_list);
        // dispatch(setJobScheduleList(schedule_list));
        if(schedule_list?.length > 0){
          setFormValues((prevValues) => ({
            ...prevValues,
            ...schedule_list[0],
            selectedDays: schedule_list[0]?.selectedDays 
          }))
        }
      }
    }
  }, [])

  const formatAMPM = time => {
    return moment.utc(time, "YYYY-MM-DD HH:mm:ss").local().format("hh:mm A");
  };

  const fetchJobScheduleList = (jobScheduleEntitiesDto) => {
    const transformed = jobScheduleEntitiesDto?.map((item) => {
      const timeIn = moment.utc(item.startTime, "YYYY-MM-DD HH:mm:ss").local().toDate();
      const timeOut = moment.utc(item.endTime, "YYYY-MM-DD HH:mm:ss").local().toDate();
      const startTime = moment.utc(item.startTime, "YYYY-MM-DD HH:mm:ss").local().format("YYYY-MM-DD HH:mm:ss");
      const endTime = moment.utc(item.endTime, "YYYY-MM-DD HH:mm:ss").local().format("YYYY-MM-DD HH:mm:ss");
  
      const selectedDays = Object.keys(dayMap).filter(day => Boolean(item[day]));
      const sortedDays = selectedDays.map(day => dayMap[day]);
      const fullSelectedDays = selectedDays.map(day => fullDayMap[day]);
  
      const startDateMoment = moment.utc(item.startDate, "YYYY-MM-DD HH:mm:ss").local();
      const endDateMoment = moment.utc(item.endDate, "YYYY-MM-DD HH:mm:ss").local();
  
      const dateRange = `${startDateMoment.format("MMM DD, YYYY")} - ${endDateMoment.format("MMM DD, YYYY")}`;
      const timeRange = `${formatAMPM(item.startTime)} - ${formatAMPM(item.endTime)}\n         for ${item.workHours.toFixed(2)} Hours`;
  
      return {
        ...item,
        startDate: startDateMoment.format("YYYY-MM-DD HH:mm:ss"),
        endDate: endDateMoment.format("YYYY-MM-DD HH:mm:ss"),
        timeIn,
        timeOut,
        startTime,
        endTime,
        dateRange,
        days: sortedDays.join(', '),
        sortedDays,
        workHours: item.workHours.toFixed(2),
        totalWorkTime: item.workHours.toFixed(2),
        timeRange,
        selectedDays: fullSelectedDays,
        workFraction: "0"
      };
    });
    return transformed;
  }

  console.log("formErrors=====", formValues);

  const updateScheduleAndErrors = (index, newSchedule) => {
    setMultiFormValues((prevValues) => {
      const updatedValues = prevValues.map((form, i) =>
        i === index ? { ...form, ...newSchedule } : form
      );
      setMultiFormErrors(updatedValues.map(() => ({
        startDate: "",
        endDate: "",
        selectedDays: "",
        timeIn: "",
        timeOut: "",
        workHours: "",
        workFraction: "",
      })));
  
      return updatedValues;
    });
  };

  const toggleDaySelection = (e, day, index) => {
    // setSelectedDays((prevSelectedDays) => {
    //   const updatedDays = prevSelectedDays.includes(day)
    //     ? prevSelectedDays.filter((d) => d !== day) // Remove if already selected
    //     : [...prevSelectedDays, day]; // Add if not selected

    //   // Update formValues state with the selectedDays
    //   setFormValues((prevValues) => ({
    //     ...prevValues,
    //     selectedDays: updatedDays, // Store the selected days in formValues
    //   }));

    //   setMultiFormValues((prevValues) =>
    //     prevValues.map((form, i) => (i === index ? { ...form, selectedDays: updatedDays } : form))
    //   );

    //   console.log("updatedDays daysss", updatedDays);

    //   return updatedDays;
    // });
    e.preventDefault();
    setMultiFormValues((prevValues) => {
      return prevValues.map((form, i) => {
        if (i === index) {
          const updatedDays = form.selectedDays?.includes(day)
            ? form.selectedDays.filter((d) => d !== day) // Remove if already selected
            : [...(form.selectedDays || []), day]; // Add if not selected
  
          console.log("Updated Days:", updatedDays);

          setFormValues((prevValues) => ({
          ...prevValues,
            selectedDays: updatedDays, // Store the selected days in formValues
          }));
  
          return { ...form, selectedDays: updatedDays };
        }
        return form;
      });
    });

    const updatedFormModified = [...formModified];
    updatedFormModified[index] = true;
    setFormModified(updatedFormModified);
  };

const isOverlapping = (startTime, endTime, startDate, endDate, schedules) => {
  let scheduleList = schedules;
  console.log("schedule====", schedules);
  const moment = require("moment");

  const getTimeInMinutes = (time) => {
    const m = moment(time);
    return m.hours() * 60 + m.minutes();
  };

  const addDayIfOvernight = (startMin, endMin) => {
    return endMin <= startMin
      ? { start: startMin, end: endMin + 1440 }
      : { start: startMin, end: endMin };
  };

  const newStartMin = getTimeInMinutes(startTime);
  const newEndMin = getTimeInMinutes(endTime);
  const { start: adjustedNewStart, end: adjustedNewEnd } = addDayIfOvernight(newStartMin, newEndMin);
  const isNewOvernight = adjustedNewEnd > 1440;

  const newStartDateMoment = moment(startDate);
  const newEndDateMoment = moment(endDate);    

  if (openIndex != null) {
    scheduleList = schedules.filter((item, index) => index !== openIndex);
  }

  console.log("scheduleList=========",scheduleList, schedules)

  const nextDay = (d) => moment().day(d).add(1, "day").format("ddd");
  const prevDay = (d) => moment().day(d).subtract(1, "day").format("ddd");

  const newSelectedDays = formValues?.selectedDays?.map(d => d.slice(0, 3)) || [];

  for (let schedule of scheduleList) {
    const existingStartMin = getTimeInMinutes(schedule.startTime);
    const existingEndMin = getTimeInMinutes(schedule.endTime);
    const { start: adjustedExistStart, end: adjustedExistEnd } = addDayIfOvernight(existingStartMin, existingEndMin);
    const isExistingOvernight = adjustedExistEnd > 1440;

    const existingStartDate = moment(schedule.startDate);
    const existingEndDate = moment(schedule.endDate);    

    const hasDateOverlap =
      newStartDateMoment.isBetween(existingStartDate, existingEndDate, null, "[)") ||
      newEndDateMoment.isBetween(existingStartDate, existingEndDate, null, "(]") ||
      (newStartDateMoment.isSameOrBefore(existingStartDate) && newEndDateMoment.isSameOrAfter(existingEndDate));

    if (!hasDateOverlap) continue;

    const existingDaysShort = schedule?.sortedDays;

    console.log("existingDaysShort====",newSelectedDays, existingDaysShort)


    for (const newDay of newSelectedDays) {
      console.log("newDay ====",newDay)
      const nextNewDay = nextDay(newDay);
      const prevNewDay = prevDay(newDay);

      if (existingDaysShort.includes(newDay)) {
        if (
          adjustedNewStart < adjustedExistEnd &&
          adjustedNewEnd > adjustedExistStart
        ) {
          return true;
        }
      }

      console.log("isNewOvernight",isNewOvernight, existingDaysShort.includes(nextNewDay))

      if (isNewOvernight && existingDaysShort.includes(nextNewDay)) {
        const newStart = adjustedNewStart;
        const newEnd = adjustedNewEnd;
        const existingStart = adjustedExistStart + 1440;
        const existingEnd = adjustedExistEnd + 1440;

        console.log("newStart======",newStart, newEnd, existingStart, existingEnd)
        if (
          newStart < existingEnd &&
          newEnd > existingStart
        ) {
          return true;
        }
      }
      console.log("isExistingOvernight======", adjustedExistStart, adjustedNewStart, adjustedNewEnd)

      if (isExistingOvernight && existingDaysShort.includes(prevNewDay)) {
        const existingStart = adjustedExistStart;
        const existingEnd = adjustedExistEnd;
        const newStart = adjustedNewStart + 1440;
        const newEnd = adjustedNewEnd + 1440;

      console.log("existingStart======",existingStart, existingEnd, newStart, newEnd)

        if (
          newStart < existingEnd &&
          newEnd > existingStart
        ) {
          return true;
        }
      }
    }
  }

  return false;
};


  const handleAddSchedule = (e, index) => {
    console.log("validateForm============", validateForm(index));
    e.preventDefault();
    if (!validateForm(index)) return;

    const weekdaysOrder = moment.weekdays();
    const sortedDays = formValues?.selectedDays
      .slice()
      .sort((a, b) => weekdaysOrder.indexOf(a) - weekdaysOrder.indexOf(b))
      .map((day) => day.slice(0, 3));

    console.log("daysoffffweeeker", daysOfWeek,formValues?.selectedDays)

    const newSchedule = {
      // endDate: moment
      //   .utc(moment(formValues?.endDate))
      //   .format("YYYY-MM-DD HH:mm:ss"),
      // endTime: moment
      //   .utc(moment(formValues?.timeOut))
      //   .format("YYYY-MM-DD HH:mm:ss"),
      // startDate: moment
      //   .utc(moment(formValues?.startDate))
      //   .format("YYYY-MM-DD HH:mm:ss"),
      // startTime: moment
      //   .utc(moment(formValues?.timeIn))
      //   .format("YYYY-MM-DD HH:mm:ss"),
      endDate: moment(formValues?.endDate).format("YYYY-MM-DD HH:mm:ss"),
      endTime: moment(formValues?.timeOut).format("YYYY-MM-DD HH:mm:ss"),
      startDate: moment(formValues?.startDate).format("YYYY-MM-DD HH:mm:ss"),
      startTime: moment(formValues?.timeIn).format("YYYY-MM-DD HH:mm:ss"),
      timeIn: formValues?.timeIn,
      timeOut: formValues?.timeOut,
      dateRange: `${moment(formValues.startDate).format(
        "MMM D, YYYY"
      )} - ${moment(formValues.endDate).format("MMM D, YYYY")}`,
      days: sortedDays.join(", "),
      sortedDays: sortedDays,
      workHours: formValues?.totalWorkTime?.toString(),
      totalWorkTime: formValues?.totalWorkTime,
      timeRange: `${moment(formValues.timeIn, "HH:mm").format(
        "hh:mm A"
      )} - ${moment(formValues.timeOut, "HH:mm").format("hh:mm A")}
         for ${formValues?.totalWorkTime} Hours`,
         selectedDays: formValues?.selectedDays,
      workFraction: formValues.workFraction,
      // ...selectedDaysObject,
      ...daysOfWeek.reduce((acc, day) => {
        acc[day.value.toLowerCase()] = formValues?.selectedDays?.includes(day.value);
        return acc;
      }, {}),
    };

    // const isOverlap = isOverlapping(newSchedule?.startTime, newSchedule?.endTime, newSchedule?.startDate, newSchedule?.endDate, newSchedule?.selectedDays, scheduleList, index)
    const isOverlap = isOverlapping(newSchedule?.startTime, newSchedule?.endTime, newSchedule?.startDate, newSchedule?.endDate, jobScheduleList)

  if (isOverlap) {
    setErrSuccessMsg({
      message: "Cannot save this schedule because its occurrence overlaps with another schedule's. Please adjust the occurrence of this schedule so there is no longer an overlap.",
      status: false,
    });
    return;
  }

    console.log("newSchedule=========", scheduleList, newSchedule, isEditing);

    if (scheduleList?.length > 0) {
        if(scheduleList?.length - 1 >= index){
          setScheduleList((prevValues) =>
            prevValues.map((form, i) => (i === index ? { ...form, ...newSchedule } : form))
          );
        }else{
          setScheduleList((prevValues) => [...prevValues, newSchedule]);
        }
        updateScheduleAndErrors(index, newSchedule);
    } else {
      setScheduleList([newSchedule]);
      updateScheduleAndErrors(index, newSchedule);
    }

    setFormModified((prevArray) =>
      prevArray.map((item, i) => (i === index ? false : item))
    );
    setSelectedDays([]);
    setOpenIndex(null);
    setFormValues((prevValues) => ({
      ...prevValues,
        // date: "",
        // timeIn: "",
        // timeOut: "",
        // startDate: "",
        // endDate: "",
        // maxEndDate: "",
        // selectedDays: [],
        // workHours: "1",
        // workFraction: "00",
        totalWorkTime: "1.00"
     }));
  };

  const handleAddMoreSchedule = async () => {
        setOpenIndex(scheduleList.length);
      const getDateTime = await getCurrentClockinClockoutTime(null, null, true);

      setMultiFormValues((prev) => {
        const updatedValues = [
          ...prev,
          { ...getDateTime, workHours: "1", workFraction: "00", totalWorkTime: "1.00" }
        ];
    
        setMultiFormErrors(
          updatedValues.map(() => ({
            startDate: "",
            endDate: "",
            selectedDays: "",
            timeIn: "",
            timeOut: "",
            workHours: "",
            workFraction: "",
          }))
        );
    
        return updatedValues;
      });

      setFormValues((prevValues) => ({
        ...prevValues,
        timeRange: null,
        dateRange: null,
        days: null,
        timeRange: null,
        sortedDays: [],
        selectedDays: [],
      }));
  };

  const handleToggleAccordion = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
    // setSelectedDays(multiFormValues[index].selectedDays);
    setFormValues((prevValues) => ({
      ...prevValues,
      ...scheduleList[index],
      ...(index > scheduleList?.length - 1 && { workHours: "1" })
    }));
  };

  const handlePostJob = (e) => {
    if (scheduleList?.length === 0) {
      setErrSuccessMsg({
        message: "Please add alteast one schedule item!",
        status: false,
      });
      return;
    }
    handleJobSubmit(e, true);
  };

  // const handleEdit = (index) => {
  //   setEditIndex(index);
  //   setIsEditing(true);
  //   setSelectedDays(scheduleList[index]?.selectedDays);
  //   console.log("scheduleList[index", scheduleList[index]);
  //   setFormValues((prev) => ({
  //     ...prev,
  //     ...scheduleList[index],
  //     workHours: scheduleList[index]?.workHours?.split(".")[0],
  //   }));
  // };

  // const handleDelete =async (index) => {
  //   const updatedList = scheduleList.filter((_, i) => i !== index);
  //   console.log("updatedList========", updatedList);
  //   setScheduleList(updatedList);
  //   // setMultiFormValues(updatedList);
  //   dispatch(setJobScheduleList(updatedList));
  //   let updatedValues = [];

  //    // Keep existing multiFormValues
  //   const currentMultiFormValues = [...multiFormValues];

  //   if(multiFormValues?.length > updatedList?.length){
  //     const preservedUnsaved = currentMultiFormValues.slice(-1)[0]; // Get last item
  //     updatedValues = [...updatedList, preservedUnsaved];
  //   }else{
  //     const getDateTime = await getCurrentClockinClockoutTime();
  //     updatedValues = [
  //       ...updatedList,
  //       { ...getDateTime, workHours: "1", workFraction: "00", totalWorkTime: "1.00" }
  //     ];
  //   }

  // setMultiFormValues(updatedValues);
  //   setMultiFormErrors(
  //     updatedValues.map(() => ({
  //       startDate: "",
  //       endDate: "",
  //       selectedDays: "",
  //       timeIn: "",
  //       timeOut: "",
  //       workHours: "",
  //       workFraction: "",
  //     }))
  //   );
  // };

  const handleDelete = async (index) => {
    const updatedList = scheduleList.filter((_, i) => i !== index);
    setScheduleList(updatedList);
    dispatch(setJobScheduleList(updatedList));
  
    const currentMultiFormValues = [...multiFormValues];
    const isUnsavedFormPresent = currentMultiFormValues?.length > scheduleList?.length;
  
    let updatedValues = [];
  
    // if (updatedList?.length === 0) {
    //   // No saved schedules left – show one fresh unsaved form
    //   const getDateTime = await getCurrentClockinClockoutTime();
    //   updatedValues = [
    //     { ...getDateTime, workHours: "1", workFraction: "00", totalWorkTime: "1.00" },
    //   ];
    // } else {
      if (isUnsavedFormPresent) {
        // Remove deleted saved schedule and preserve unsaved form
        const preservedUnsaved = currentMultiFormValues.slice(-1)[0];
        const savedForms = currentMultiFormValues.slice(0, scheduleList?.length); // only saved ones
        const updatedSavedForms = savedForms.filter((_, i) => i !== index);
        updatedValues = [...updatedSavedForms, preservedUnsaved];
      } else {
        // Only saved forms exist — remove one, no new unsaved form
        if (updatedList?.length === 0) {
            // No saved schedules left – show one fresh unsaved form
            const getDateTime = await getCurrentClockinClockoutTime(null, null, true);
            updatedValues = [
              { ...getDateTime, workHours: "1", workFraction: "00", totalWorkTime: "1.00" },
            ];
         }else{
          updatedValues = updatedList;
         }
      }
    // }
  
    setMultiFormValues(updatedValues);
    if(updatedList?.length == 0){
      const multi_form_values = multiFormValues[multiFormValues?.length - 1];
      setOpenIndex(0);
      setFormValues((prevValues) => ({
        ...prevValues,
        startDate: multi_form_values?.startDate,
        endDate: multi_form_values?.endDate,
        selectedDays: multi_form_values?.selectedDays,
        timeIn: multi_form_values?.timeIn,
        timeOut: multi_form_values?.timeOut,
        workHours: multi_form_values?.workHours,
        workFraction: multi_form_values?.workFraction,
        totalWorkTime: multi_form_values?.totalWorkTime,
      }));
    }else{
      setOpenIndex(null);
    }
    // Reset errors accordingly
    setMultiFormErrors(
      updatedValues.map(() => ({
        startDate: "",
        endDate: "",
        selectedDays: "",
        timeIn: "",
        timeOut: "",
        workHours: "",
        workFraction: "",
      }))
    );
  };

  console.log("ltiFormValues.le====",formValues, multiFormValues);


  return (
    <div className="tw-faq-section">
      <div className="accordion tw-faq" id="sf-faq-accordion">
        {/* {multiFormValues.length > 0 ? ( */}
          {multiFormValues?.length > 0 && multiFormValues?.map((schedule, index) => {
            const item = schedule?.startDate !== "" ? schedule : formValues;
            return (
            <div className="accordion-item">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={`#schedule-${index}`}
                // aria-expanded="true"
                onClick={() => handleToggleAccordion(index)}
                aria-expanded={openIndex === index}
              >
                <div
                  className="d-flex justify-content-between align-items-center"
                  style={{ width: "100%" }}
                >
                  <div>
                    {schedule?.dateRange && (
                      <>
                        <strong>{schedule.dateRange}</strong> on{" "}
                        <strong>{schedule.days}</strong>
                        <br />
                        {schedule.timeRange}
                      </>
                    )}
                  </div>
                  <div>
                    {/* <i
                      className="fas fa-edit text-primary me-3"
                      style={{ cursor: "pointer" }}
                      onClick={() => handleEdit(index)}
                    ></i> */}
                    {/* <i
                      className="fas fa-trash text-danger mt-2"
                      style={{ cursor: "pointer" }}
                      onClick={() => handleDelete(index)}
                    ></i> */}
                  </div>
                </div>
              </button>

              <div
                id={`schedule-${index}`}
                className={`accordion-collapse collapse ${
                  openIndex === index ? "show" : ""
                }`}
                data-bs-parent="#sf-faq-accordion"
                style={{ backgroundColor: "#fff", padding: "15px" }}
              >
                <>
                  <div className="row">
                    <div className="col-xl-6 col-lg-6 col-md-12">
                      <div className="form-group">
                        <label> Start Date</label>
                        <div className="ls-inputicon-box">
                          <ReactDatePicker
                            className="form-control"
                            name="startDate"
                            id="startDate"
                            selected={item?.startDate}
                            onChange={(date) => handleDatePickerChange(date, "startDate", index)}
                            dateFormat="MM-dd-yyyy"
                            placeholderText="Start Date"
                            minDate={new Date()}
                          />
                          <i className="fs-input-icon fas fa-calendar-alt" />
                        </div>
                        {multiFormErrors[index]?.startDate && (
                          <span className="error-message">{multiFormErrors[index]?.startDate}</span>
                        )}
                      </div>
                    </div>
                    <div className="col-xl-6 col-lg-6 col-md-12">
                      <div className="form-group">
                        <label> End Date</label>
                        <div className="ls-inputicon-box">
                          <ReactDatePicker
                            className="form-control"
                            name="endDate"
                            id="endDate"
                            selected={item?.endDate}
                            onChange={(date) => handleDatePickerChange(date, "endDate", index)}
                            dateFormat="MM-dd-yyyy"
                            placeholderText=" End Date"
                            minDate={item?.startDate || new Date()}
                            // maxDate={
                            //   userInfo?.paymentMethod === "stripe" ||
                            //   empDetailsInfo?.paymentMethod === "stripe"
                            //     ? formValues?.maxEndDate
                            //     : null
                            // }
                          />
                          <i className="fs-input-icon fas fa-calendar-alt" />
                        </div>
                        {multiFormErrors[index]?.endDate && (
                          <span className="error-message">{multiFormErrors[index]?.endDate}</span>
                        )}
                      </div>
                    </div>
                  </div>

                  {console.log("item?.selectedDays",item?.selectedDays)}

                  <div className="row">
                    <div className="col-12">
                      <label>Select Days</label>
                      <div className="d-flex gap-2">
                        {daysOfWeek.map((day, ind) => (
                          <button
                            key={ind}
                            className={`btn ${
                              item?.selectedDays?.includes(day.value)
                                ? "btn-primary"
                                : "btn-outline-secondary"
                            } mb-3`}
                            onClick={(e) => toggleDaySelection(e, day.value, index)}
                          >
                            {day.label}
                          </button>
                        ))}
                      </div>
                      {multiFormErrors[index]?.selectedDays && (
                        <span className="error-message">{multiFormErrors[index]?.selectedDays}</span>
                      )}
                    </div>

                    {/* {item?.timeIn != "" && ( */}
                    <div className="col-xl-6 col-lg-6 col-md-6">
                      {console.log("formValues.timeIn", item?.timeIn)}

                      <div className="form-group">
                        <label>Start Time</label>
                        <div className="ls-inputicon-box">
                          <ReactDatePicker
                            className="form-control"
                            selected={item?.timeIn}
                            onChange={(date) => handleTimeChange(date, "timeIn", index)}
                            showTimeSelect
                            showTimeSelectOnly
                            timeIntervals={15} // 15-minute intervals
                            timeCaption="Time"
                            dateFormat="h:mm aa" // AM/PM format
                            placeholderText="Select time"
                          />
                          <i className="fs-input-icon fa fa-clock" />
                        </div>
                        {multiFormErrors[index]?.timeIn && (
                          <span className="error-message">{multiFormErrors[index]?.timeIn}</span>
                        )}
                      </div>
                    </div>
                    {/* )} */}

                    {/* {item?.timeOut != "" && ( */}
                    <div className="col-xl-6 col-lg-6 col-md-6">
                      {console.log("item?.timeIn", item?.timeOut)}
                      <div className="form-group">
                        <label>End Time</label>
                        <div className="ls-inputicon-box">
                          <ReactDatePicker
                            className="form-control"
                            selected={item?.timeOut}
                            onChange={(date) => handleTimeChange(date, "timeOut", index)}
                            showTimeSelect
                            showTimeSelectOnly
                            timeIntervals={15} // 15-minute intervals
                            timeCaption="Time"
                            dateFormat="h:mm aa" // AM/PM format
                            placeholderText="Select time"
                          />
                          <i className="fs-input-icon fa fa-clock" />
                        </div>
                        {multiFormErrors[index]?.timeOut && (
                          <span className="error-message">{multiFormErrors[index]?.timeOut}</span>
                        )}
                      </div>
                    </div>
                    {/* )} */}

                    {!isEditing && workHoursEnabled && (
                      <>
                        <div className="col-12 text-center mt-2">
                          <span className="font-weight-bold">
                            {`${item?.totalWorkTime}`} Work Hours
                          </span>
                          <button
                            className="btn btn-sm btn-outline-primary ms-3"
                            onClick={() => setIsEditing(!isEditing)}
                          >
                            <i className="fas fa-edit"></i> {/* Font Awesome Edit Icon */}
                          </button>
                        </div>
                        {multiFormErrors[index]?.workHours && (
                              <span className="error-message">{multiFormErrors[index]?.workHours}</span>
                          )}
                      </>
                      
                    )}

                  {isEditing && (
                    <>
                      <div className="col-xl-6 col-lg-6 col-md-6">
                        <div className="form-group">
                          <label>Hours</label>
                          <div className="ls-inputicon-box">
                            <input
                              className="form-control"
                              name="workHours"
                              type="number"
                              placeholder="Hours"
                              value={Math.floor(formValues?.workHours) || formValues?.workHours}
                              // maxLength={12}
                              onChange={(e) => {
                                handleChange(e, "workHours", index);
                              }}
                            />
                            {/* <i className="fs-input-icon fa fa-phone-alt" /> */}
                          </div>
                          {multiFormErrors[index]?.workHours && (
                            <span className="error-message">{multiFormErrors[index]?.workHours}</span>
                          )}
                        </div>
                      </div>
                      <div className="col-xl-6 col-lg-6 col-md-6">
                        <div className="form-group">
                          <label>Minutes</label>
                          <div className="ls-inputicon-box">
                            <select
                              className="form-control"
                              name="workFraction"
                              value={item?.workFraction}
                              onChange={(e) => {
                                handleChange(e, "workFraction", index);
                              }}
                            >
                              <option value="00">00</option>
                              <option value="15">15</option>
                              <option value="30">30</option>
                              <option value="45">45</option>
                            </select>
                          </div>
                          {multiFormErrors[index]?.workFraction && (
                            <span className="error-message">{multiFormErrors[index]?.workFraction}</span>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                  </div>

                  <div className="row mt-3">
                    <div className="col-12 text-center d-flex justify-content-center">
                      <button className="btn site-button save-button" onClick={(e) => handleAddSchedule(e, index)} disabled={scheduleList?.length > 0 && !formModified[index]}>
                          Save
                      </button>
                      {/* {((index !== scheduleList?.length - 1 || scheduleList[scheduleList?.length - 1]?.days) && scheduleList?.length != 0) && ( */}
                      {console.log("(index === scheduleList?.length - 1 && scheduleList?.length != 0)",index, scheduleList?.length - 1,(index === scheduleList?.length - 1 && scheduleList?.length != 0))}
                      {(index <= scheduleList?.length - 1 && scheduleList?.length != 0) && (
                        <button className="btn site-button save-button ms-1 bg-danger" onClick={() => handleDelete(index)}>
                          Delete
                        </button>
                      )}
                    </div>
                  </div>
                </>
                {/* <AddScheduleForm schedule={schedule} index={index}/> */}
              </div>
            </div>
          )})
        // ) : (
        //   <div className="accordion-item">
        //     <button
        //       className="accordion-button collapsed"
        //       type="button"
        //       data-bs-toggle="collapse"
        //       data-bs-target={`#scheduled`}
        //       aria-expanded="true"
        //     ></button>

        //     <div
        //       id={`scheduled}`}
        //       className="accordion-collapse collapse show"
        //       data-bs-parent="#sf-faq-accordion"
        //       style={{ backgroundColor: "#fff", padding: "15px" }}
        //     >
        //       <AddScheduleForm schedule={formValues} index={0}/>
        //     </div>
        //   </div>
        // )
        }

        {console.log("scheduleList?.length > 0 && scheduleList?.length === jobScheduleList?.length",scheduleList?.length > 0, scheduleList?.length === jobScheduleList?.length, scheduleList?.length, jobScheduleList?.length)}
        {scheduleList?.length > 0 && scheduleList?.length === multiFormValues?.length && (
          <div className="row mt-3">
            <div className="col-12 text-center d-flex justify-content-center">
              <button
                className="btn site-button save-button"
                onClick={handleAddMoreSchedule}
              >
                Add
              </button>
            </div>
          </div>
        )}

        {/* <h4 className="mt-5">Schedule List</h4>
        <div className="row mt-3">
          <div className="col-12">
            {scheduleList?.length === 0 ? (
              <p>No schedules added.</p>
            ) : (
              <ul className="list-group">
                {scheduleList?.map((schedule, index) => (
                  <li
                    key={index}
                    className="list-group-item d-flex justify-content-between align-items-center"
                  >
                    <div>
                      <strong>{schedule.dateRange}</strong> on{" "}
                      <strong>{schedule.days}</strong>
                      <br />
                      {schedule.timeRange}
                    </div>
                    <div>
                      <i
                        className="fas fa-edit text-primary me-3"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleEdit(index)}
                      ></i>
                      <i
                        className="fas fa-trash text-danger"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleDelete(index)}
                      ></i>
                    </div>
                  </li>
                ))}
              </ul>
            )}
          </div>
        //    </div>
        //     </div>
        //   </div> 
        </div> */}

        <div className="twm-tabs-style-2 mt-5 d-flex justify-content-center">
          <div className="nav nav-tabs">
            <div className="text-left">
              <button
                type="submit"
                className="site-button nav-item"
                onClick={() => {
                  setShowScheduleScreen(false);
                  handleHideJobType(true);
                }}
              >
                Back
              </button>
            </div>
            <div className="text-left">
              <button
                type="submit"
                className="site-button nav-item m-l5"
                onClick={(e) => {
                  handlePostJob(e);
                }}
              >
                {isLoading ? <Spinner /> : "Post Job"}
              </button>
            </div>
          </div>
        </div>
        {errSuccessMesg?.message !== "" ? (
          <Toast message={errSuccessMesg} />
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default ScheduleJobScreen;
